import { Component, OnInit } from '@angular/core';
// import { MatDialogRef } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DrawCustomRoomService } from '../../../Component(2D and 3D)/2D/draw-custom-room.service';
import { AuthService } from '../../../services/auth.service';
import { DoneShapeTemplatesService } from '../../../services/done-shape-templates.service';
import { BuildFloorService } from '../../../services/build-floor.service';
import { StageService } from '../../../services/stage.service';
import { RoomStateManagerService } from '../../../services/room-state-manager.service';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { DeckHeightService } from '../../../services/deck-height.service';
import {SceneryService} from '../../../services/scenery.service';
import { RailingGenerationService } from '../../../services/railing/services/railing-generation.service';
import { DataForDisplayingMenuItemsService } from '../../../services/data-for-displaying-menu-items.service';
import { CameraService } from '../../../services/camera.service';
import { ZoomService } from '../../../services/zoom.service';
import { DockModeService } from '../../../services/dock-mode.service';

@Component({
  selector: 'app-modal-new-project',
  templateUrl: './modal-new-project.component.html',
  styleUrls: ['./modal-new-project.component.scss']
})
export class ModalNewProjectComponent implements OnInit {

  projectType = 'home';
  deckShape = 'rectangle';
  isAdmin: boolean = false;
  isDock: boolean = false;
  // dock projects keep projectType='dock'; Home/Cottage vs Business/Commercial
  // (spec p.11) is stored separately as dockSubtype
  dockSubtype = 'home';
  shapes: Array<Object> = [];
  currentStep: number;

  constructor(
    public dialogRef: MatDialogRef<ModalNewProjectComponent>,
    public dialog: MatDialog,
    public drawCustomRoom: DrawCustomRoomService,
    public auth: AuthService,
    public shapeTemplate: DoneShapeTemplatesService,
    public buildFloor: BuildFloorService,
    public stage: StageService,
    public roomStateManager: RoomStateManagerService,
    private projectManagerService: ProjectManagerService,
    private deckHeightService: DeckHeightService,
    private env: SceneryService,
    private railingGenerationService: RailingGenerationService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService,
    private cameraService: CameraService,
    private zoomService: ZoomService,
    private dockModeService: DockModeService
  ) {
    this.shapes = this.shapeTemplate.shapes;
    this.isDock = this.dockModeService.isDockMode();
    if (this.isDock) {
      this.projectType = DockModeService.PROJECT_TYPE;
      // spec p.11: docks pick from the same six shapes, Rectangle preselected
      this.projectManagerService.setDockSubtype(this.dockSubtype);
    }
  }

  ngOnInit() {
    if (this.auth.getRole() == "admin") {
      this.isAdmin = true;
    }
    let cont: any = document.getElementById('shapes-wrapper-for-menu');
    if (this.isAdmin) {
      for (let i = 0; i < cont.childElementCount; i++) {
        cont.children[i].style.maxWidth = '80px';
      }
    }
    else {
      for (let i = 0; i < cont.childElementCount; i++) {
        cont.children[i].style.maxWidth = '90px';
      }
    }
    this.currentStep = this.dataForDisplayingMenuItemsService.getCurrentStep();
  }

  setProjectType(type: string) {
    // Dock projects are always persisted as projectType='dock'; the
    // Home/Cottage vs Business/Commercial answer goes into dockSubtype
    if (this.isDock) {
      this.dockSubtype = type;
      this.projectManagerService.setDockSubtype(type);
      this.projectManagerService.setProjectType(DockModeService.PROJECT_TYPE);
      return;
    }
    this.projectType = type;
    this.projectManagerService.setProjectType(type);
  }

  setDeckShape(type: string) {
    this.deckShape = type;
  }

  closeDialog() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(result => {
      this.railingGenerationService.buildRailing(this.railingGenerationService.isVisible);
    });
  }

  checkDeckShape() {
    this.dataForDisplayingMenuItemsService.setProToolsResetProj();
    if (this.deckShape == 'scratch') {
      this.drawCustomRoom.isScratch = true;
      if(this.currentStep === 2){
        this.railingGenerationService.buildRailingIfVisible();
      }
    }
    else {
      if (this.isDock) {
        // projectType must be 'dock' BEFORE startNewProject():
        // setDefaultParams() inside it branches on the project type to pick
        // the DockRail defaults (resetProject() has wiped it by now)
        this.projectManagerService.setProjectType(DockModeService.PROJECT_TYPE);
      }
      this.dataForDisplayingMenuItemsService.startNewProject();
      const template = []
      this.shapes[this.deckShape].forEach(el => {
        const point = Object.assign({}, el);
        if (this.isDock) {
          // dock sides start without railing — anchors on the railing step
          // (spec pp.13-15) add it side by side
          point.noRail = true;
        }
        template.push(point)
      })
      this.roomStateManager.setPoints(template);
      this.projectManagerService.setProjectType(this.projectType);
      // docks start on the lake scene (existing lakefront asset until dedicated
      // lake scenes are authored), decks on the neutral grid
      this.env.change(this.isDock ? 'lakefront' : 'grid');
      this.buildFloor.setCompundFloorPosY(53.34);
      this.buildFloor.buildFloor({ points: template, height: 53.34, mainFloor: true });
      this.deckHeightService.setDeckHeight(21);
      this.railingGenerationService.buildRailing(false);
      this.cameraService.reset();
      this.zoomService.reset();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-new-project/modal-new-project.component.ts